import {Link} from 'react-router-dom'

const SppbDocTypeItem = ({
  page,
  index,
  id,
  name,
  code,
  onDeleteClick,
  table,
}) => {
  return (
    <tr>
      <td className='fw-medium'>{index + page + 1}</td>
      <td>
        <div className='hstack gap-3 fs-15'>
          <Link to={`/app/${table}/edit/${id}`} className='link-warning'>
            <i className='ri-edit-2-line'></i>
          </Link>
          <Link
            to='#'
            className='link-danger'
            onClick={() => {
              onDeleteClick(id)
            }}
          >
            <i className='ri-delete-bin-5-line'></i>
          </Link>
        </div>
      </td>
      <td>{name}</td>
      <td>{code}</td>
    </tr>
  )
}

export default SppbDocTypeItem
